<template>
    <router-link :to="{ name: 'accessory-sheet-summary', params: {id:  datas.code, name: slugifyName(datas), saveRoute: saveRoute}}" :style="cssVars" class="accessory-card" :class="{'is-bestseller': isBestSeller, 'is-new' : isNew}">
        <img :src="picture" alt="" class="picture" />
      <!--@TODO soucis sur le family label pour les attachments qui est celui du nom de produit...-->
        <div class="category" v-if="categoryAccessory">{{ categoryAccessory }}</div>
        <div class="title">{{ datas.label ? datas.label : 'n.a' }}</div>
        <span class="bottom-link" :class="brandColor">{{ $t("see_the_family") }}</span>
        <div class="video-badge is-grey" v-if="datas.hasVideo" aria-label="Video badge"></div>
    </router-link>
</template>

<script>

    import {mapState} from "vuex";

    const defaultPicture = require('@/assets/img/no_image_available.jpg');

    export default {
        name: 'AccessoryCardSummary',
        props: {
            datas: {
                type: Object
            },
            saveRoute: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                picture: defaultPicture,
                categoryAccessory:'',
                isBestSeller:false,
                isNew:false,
            }
        },
      computed: {
        ...mapState({
          categories: state => state.settings.categories,
        }),
        cssVars() {
          return {
            '--new-label': "'"+this.$t('new')+"'",
          }
        }
      },
        watch: {
            datas() {
                this.picture = defaultPicture;
                this.isBestSeller=this.datas.best_seller && this.getEnv !== 'production' && this.$store.state.settings.region==='R1'
                this.isNew=this.datas.isNew
                this.fetchDatas();

            }
        },
        created() {
            this.fetchDatas();
        },
        methods: {
          fetchDatas() {
            if (this.datas.mainVisual) {
              this.picture = this.datas.mainVisual.small;
            }

              this.categoryAccessory = this.datas.family.label;

          },
        },
    }
</script>

<style lang="scss">
    .accessory-card {
        position: relative;
        height: 300px;
        width: 230px;
        text-align: center;
        padding: 0 20px;
        border-radius: 20px;
        box-shadow: 20px 20px 74px 0 rgba(0, 0, 0, 0.15);
        background-color: $white;
        border: solid 2px $white;
        transition: border-color 0.3s ease;

        @each $brand in $brands {
            .brand-#{$brand} & {
                &:hover {
                    border: solid 2px brand-color($brand);
                }
            }
        }

      &.is-bestseller {
        &:before {
          content: '';
          position: absolute;
          top: 9px;
          left: 9px;
          width: 73px;
          height: 34px;
          background-image: url('~@/assets/img/best-seller.png');
          background-size: 73px 34px;
        }
      }

      &.is-new {
        &:after {
          content: var(--new-label);

          position: absolute;
          top: 9px;
          right: 9px;
          //width: 73px;
          //height: 34px;
          background-color: #eb1212;
          color:#ffffff;
          border-radius:30px;
          padding:5px 15px;
          font-size:10px;
          // background-size: 73px 34px;
        }
      }

        .picture {
            width: auto;
            height: 150px;
            padding: 10px 0
        }

        .title {
            @include small-title($black);
            line-height: 18px;
            margin: 5px 0;
        }

        .bottom-link {
            position: absolute;
            bottom: 20px;
            left: 0;
            right: 0;
            text-transform: uppercase;
            font-size: 13px;
            font-weight: 700;

            &:after {
                @include icomoon;
                content: '\e90e';
                margin-left: 20px;
            }
        }

        .video-badge {
            position: absolute;
            top: 13px;
            right: 13px;
        }


    }
</style>